import React from "react";
import { Switch, Route } from "react-router-dom";
import Show from "../containers/showContainer"

function RouterMenuUser() {
    return (
        <Route path="/MenuUser">
            <Switch>
                <Route path="/MenuUser" exact>
                    <Show />
                </Route>
            </Switch>
        </Route>
    );
}
export default RouterMenuUser;
